import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import icon from '../../../../public/chrome-web-store.png';
import CodeImage from './install.png';

export default function InstallDialog({ title, onClose, code }) {
    const extensionLink = 'https://chrome.google.com/webstore/detail/new-tab-studio-countdown/epngggilgnflanfabeldfpbgponcgpgl';

    return (
        <div>
            <Dialog
                open={true}
                onClose={onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{title ? title : "Install theme"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <ol>
                            <li>Install <a href={extensionLink} target={'_blank'}>New Tab Studio</a></li>

                            <a href={extensionLink} target={'_blank'}>
                                <img src={icon} alt={'Chrome Web Store'} width={248}/>
                            </a>

                            <li>Copy the code <strong>{code}</strong></li>
                            <li>Paste the code to input as shown below:</li>

                            <img src={CodeImage} width={'250px'} style={{ border: '3px solid #555', borderRadius: 5, margin: 5 }}/>
                        </ol>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}